import type { AxiosPromise } from 'axios'
import request from '@core/request'

/**
 * 文件上传
 * @returns {AxiosPromise}
 */
export function getHomePage(data: any): AxiosPromise {
  return request({
    method: 'get',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/dataCenter/homePage',
    data,
  })
}
export function generateUk(data: any): AxiosPromise {
  return request({
    method: 'get',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/assess/generateUk',
    data,
  })
}

export function getConsumeInfo(data: {
  consumeItemId: number | string
  consumeType: string
  isOut: number | string
}): AxiosPromise {
  return request({
    method: 'post',
    url: '/dataCenter/getConsumeInfo',
    data,
  })
}

/**
 * 权益流水汇总及分页明细
 */
export function equityPage(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/dataCenter/equityPage',
    data,
  })
}
